import React, { useState } from 'react';
import { FiCheckSquare, FiMinusSquare, FiSquare } from 'react-icons/fi';

const SearchDropdownMultiselectOpenList = ({
  onChoose,
  items,
  value,
  subvalue,
  depth,
}) => {
  const [openGroup, setOpenGroup] = useState(null);

  const handleGroupToggle = (groupName) => {
    setOpenGroup((prevOpenGroup) =>
      prevOpenGroup === groupName ? null : groupName
    );
  };

  const setSubregion = (e, id, subid) => {
    e.stopPropagation();
    onChoose(id, subid);
  };

  return (
    <div className="dropdown-open">
      {items.length &&
        items.map((item) => {
          const index = value.indexOf(item.id);

          if (item.children) {
              <div
                  key={item.id}>
                <div
                  className={`r on`}
                  onClick={() => handleGroupToggle(item.group)}
                >
                  {item.name}
                </div>
                {!!depth && item.subitems.length ? (
                  <div key={`subregions${item.id}`}>
                    {item.subitems.map((subregion) => (
                      <p
                        key={subregion.id}
                        className={`r subregion ${
                          subvalue.includes(subregion.id) ? 'on' : ''
                        }`}
                        onClick={(e) => setSubregion(e, item.id, subregion.id)}
                      >
                        {subvalue.includes(subregion.id) ? (
                          <FiCheckSquare />
                        ) : (
                          <FiSquare />
                        )}
                        {subregion.name}
                      </p>
                    ))}
                  </div>
                ) : null}
              </div>

          }

          if (index !== -1) {
            let isAnyItemChosen = false;
            if (Array.isArray(item.subitems)) {
              isAnyItemChosen = item.subitems.some((subitem) =>
                subvalue.includes(subitem.id)
              );
            }
            return (
              <div
                  key={item.id}>
                <div
                  className={`r on ${isAnyItemChosen ? ' r_chosen' : ''}`}
                  onClick={() => onChoose(item.id)}
                >
                  {value.includes(item.id) ? (
                    <FiCheckSquare />
                  ) : isAnyItemChosen ? (
                    <FiMinusSquare />
                  ) : (
                    <FiSquare />
                  )}
                  {item.name}
                </div>
                {!!depth && item.subitems.length ? (
                  <div key={`subregions${item.id}`}>
                    {item.subitems.map((subregion) => (
                      <p
                        key={subregion.id}
                        className={`r subregion ${
                          subvalue.includes(subregion.id) ? 'on' : ''
                        }`}
                        onClick={(e) => setSubregion(e, item.id, subregion.id)}
                      >
                        {subvalue.includes(subregion.id) ? (
                          <FiCheckSquare />
                        ) : (
                          <FiSquare />
                        )}
                        {subregion.name}
                      </p>
                    ))}
                  </div>
                ) : null}
              </div>
            );
          } else {
            let isAnyItemChosen = false;
            if (Array.isArray(item.subitems)) {
              isAnyItemChosen = item.subitems.some((subitem) =>
                subvalue.includes(subitem.id)
              );
            }
            return (
              <p
                key={item.id}
                className={`r${isAnyItemChosen ? ' r_chosen' : ''}`}
                onClick={() => onChoose(item.id)}
              >
                {value.includes(item.id) ? (
                  <FiCheckSquare />
                ) : isAnyItemChosen ? (
                  <FiMinusSquare />
                ) : (
                  <FiSquare />
                )}
                {item.name}
                {!!depth && item.subitems.length
                  ? ` (${item.subitems.length})`
                  : ''}
              </p>
            );
          }
        })}
    </div>
  );
};

export default SearchDropdownMultiselectOpenList;
